import {
  ToggleBlockType
} from './block-type'

export class HeaderOne extends ToggleBlockType {
  getBlockType = () => 'header-one'

  getButtonText = () => 'H1'
}



/** WEBPACK FOOTER **
 ** ./lib/toggle/block-type/header-one.js
 **/